import { reactive, onMounted } from 'vue'
import { numberAdd, numberSub } from '../../../utils/index'
export function useTaskNum({ items = [] }) {
  const taskNum = reactive({
    // total: 0,
    // done: 0,
    // 一个主行加所属的从行为一个任务
    amountTotal: 0, //已经扫了的数量
    planTotal: 0, // 所有的计划数量
    taskTotal: 0, // 所有的任务数量
    taskDone: 0, // 已经扫了的任务数量
    taskRemaining: 0, // 待扫的任务数量
  })

  const getParent = (row) => {
    return row.parent || row._ID
  }
  const setTaskNum = (tableData) => {
    const parentMap = new Map()
    const masterMap = new Map()
    for (const item of items) {
      if (item.master) {
        masterMap.set(getParent(item), item.plan || 0)
      }
      parentMap.set(getParent(item), numberAdd(parentMap.get(getParent(item)) || 0, item.amount))
    }
    for (const tableDataItem of tableData) {
      parentMap.set(
        getParent(tableDataItem),
        numberAdd(parentMap.get(getParent(tableDataItem)) || 0, tableDataItem.amount)
      )
    }

    taskNum.amountTotal = parentMap.values().reduce((pre, cur) => numberAdd(pre, cur), 0)
    taskNum.planTotal = masterMap.values().reduce((pre, cur) => numberAdd(pre, cur), 0)
    taskNum.taskTotal = masterMap.size
    taskNum.taskDone = masterMap
      .keys()
      .filter((parent) => masterMap.get(parent) <= parentMap.get(parent))
      .toArray().length
    taskNum.taskRemaining = numberSub(taskNum.taskTotal, taskNum.taskDone)
  }

  onMounted(() => setTaskNum([]))
  return {
    taskNum,
    setTaskNum,
  }
}
